import React from 'react';
import { Combo } from 'fw/forms';

class CertificationVOBStatusCombo extends React.PureComponent {
    constructor(props) {
        super(props);
        this.state = {};
        this._isMounted = false;
    }

    completed = () => { return this._ctrl.completed(); }
    flag = () => { return this._ctrl.flag(); }

    componentDidMount = () => {
        this._isMounted = true;

        this.loadCertificationStatus(null);
    }

    loadCertificationStatus = () => {
        let items = [];

        items.push({ label: "Certified", value: "CER"});
        items.push({ label: "Expired", value: "EXP"});

        this.setState({items});
    }

    componentWillUnmount() {
        this._isMounted = false;
    }

    render() {
        return (
            <Combo
                {...this.props}
                placeholder={this.props.placeholder ? this.props.placeholder : "Status"}
                items={this.state.items}
                searchable={true}
                ref={(c) => { this._ctrl = c }} />
        )
    }
}

export default CertificationVOBStatusCombo;

// Mark this as a form component
CertificationVOBStatusCombo.defaultProps = {
    formControl: true,
    managed: false
};



// WEBPACK FOOTER //
// ./src/areas/shared/controls/certificationVOBStatusCombo/CertificationVOBStatusCombo.js